import getApi from '../../api'
import { Survey, SurveyApi } from '../../model/Survey'

export const updateSurvey = (surveyId: number, survey: Partial<SurveyApi>) =>
  getApi().put<Survey>(`surveys/${surveyId}`, survey)
